app.factory('SupplierContactTypes', function($resource){
  return $resource('/supplierContactTypes', {}, {}).query().$promise;
});
